module.exports = __webpack_public_path__ + "media/assets/svgs/outlookCalendarIcon-41d16cde92f23c0849a7ddfd2065aa2e.svg";